import { BP_BOOKING_KEY, BP_EMAIL_ADDRESS_KEY, BP_FIRST_DATA_PAYMENT_FORM_KEY } from "../../../constants/balance-payments";
import SessionDataManager from "../../../util/storage-manager";

export default class BalancePaymentDetails {
  constructor(context) {
    this.context = context;

    this.init();
  }

  init() {
    const loginPage = this.context.dataset.balancePaymentLoginPage;

    const storedBookingDetails = SessionDataManager.getStorageItem(BP_BOOKING_KEY);
    this.bookingDetails = JSON.parse(storedBookingDetails);

    if (!storedBookingDetails) {
      window.location.href = loginPage;
    }

    this.amountPaid = this.bookingDetails.Detail.FinanceDetails.AmountPaid;
    this.totalAmount = this.bookingDetails.Detail.FinanceDetails.TotalPrice;
    this.amountDue = this.totalAmount - this.amountPaid;

    const poundsGB = Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: this.bookingDetails.CurrencyCode,
    });

    this.payFullAmountLabel = this.context.querySelector('[data-element="pay-full-amount-label"]');
    this.payFullAmountLabel.innerHTML = poundsGB.format(this.amountDue);
    this.payCustomAmountLabel = this.context.querySelector('[data-element="pay-custom-amount-label"]');
    this.payCustomAmountLabel.innerHTML = poundsGB.format(this.amountDue);

    this.balanceDueLabel = this.context.querySelector('[data-element="due-date-label"]');
    this.balanceDueLabel.innerHTML = new Date(this.bookingDetails.Detail.FinanceDetails.BalanceDueDate).toLocaleDateString('en-GB');

    this.hiddenFormSubmit = this.context.querySelector('[data-element="submit-button"]');

    if (this.amountDue > 0 && !this.bookingDetails.Detail.IsCancelled) {
      this.customAmountInput = this.context.querySelector('[data-element="custom-amount-input"]');
      this.customAmountInput.setAttribute('max', this.amountDue);
      this.fullAmountRadioInput = this.context.querySelector('[data-element="full-amount-radio-input"]');
      this.customAmountRadioInput = this.context.querySelector('[data-element="custom-amount-radio-input"]');
      this.customAmountRadioInput.addEventListener('change', () => {
        this.setInputValidation(this.customAmountInput);
        if (this.customAmountInput.value !== '') {
          this.setPaymentValue();
        }
      });
      this.customAmountInput.addEventListener('change', this.setPaymentValue);
      this.fullAmountRadioInput.addEventListener('change', this.setPaymentValue);

      this.storeIdInput = this.context.querySelector('[data-element="store-id-input"]');
      this.txnDateInput = this.context.querySelector('[data-element="txn-date-input"]');
      this.currencyInput = this.context.querySelector('[data-element="currency-input"]');
      this.currencyInput.value = this.bookingDetails.CurrencyCodeNumeric;
      this.oidInput = this.context.querySelector('[data-element="oid-input"]');

      this.emailInput = this.context.querySelector('[data-element="email-input"]');
      this.emailInput.addEventListener('blur', this.storeEmailAddress);
      this.emailInput.addEventListener('keyup', () => {
        const waitTime = 1000;

        setTimeout(() => {
          this.storeEmailAddress();
        }, waitTime);
      });

      // hidden form fields
      this.chargeTotalInput = this.context.querySelector('[data-element="charge-total-input"]');
      this.hashInput = this.context.querySelector('[data-element="hash-input"]');
      this.hiddenFormSubmit.addEventListener('click', this.validateForm);
      this.setPaymentValue();
    } else {
      this.hiddenFormSubmit.setAttribute('disabled', true);
      if (this.bookingDetails.Detail.IsCancelled) {
        this.validationEL = this.context.querySelector('[data-element="total-amount-validation-cancelled"]');
      } else {
        this.validationEL = this.context.querySelector('[data-element="total-amount-validation-total"]');
      }
      this.validationEL.classList.add('active');
    }
  }

  storeEmailAddress = () => {
    SessionDataManager.setStorageItem(BP_EMAIL_ADDRESS_KEY, this.emailInput.value);

    if (this.emailInput.value !== "" && (this.customAmountRadioInput.checked && this.customAmountInput.value !== "" || this.fullAmountRadioInput.checked)) {
      this.hiddenFormSubmit.removeAttribute('disabled');
    }
  }

  setInputValidation = (input) => {
    input.setAttribute("required", "");
  }

  validateForm = () => {
    let isAmountValid = false;
    let chargeTotal;
    if (this.customAmountRadioInput.checked && this.customAmountInput.value !== "") {
      chargeTotal = Number(this.customAmountInput.value).toFixed(2);

      if (chargeTotal <= this.amountDue && chargeTotal >= 1) {
        isAmountValid = true;
      }
    } else if (this.fullAmountRadioInput.checked) {
      chargeTotal = Number(this.amountDue).toFixed(2);
      isAmountValid = true;
    }

    const emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!isAmountValid | (this.emailInput.value === "" | !emailRegex.test(this.emailInput.value))) {
      this.context.classList.add('was-validated');
      this.hiddenFormSubmit.setAttribute('disabled', true);
    }
  }

  setPaymentValue = () => {
    let isAmountValid = false;
    let chargeTotal;

    if (this.customAmountRadioInput.checked && this.customAmountInput.value !== "") {
      chargeTotal = Number(this.customAmountInput.value).toFixed(2);

      if (chargeTotal <= this.amountDue && chargeTotal >= 1) {
        isAmountValid = true;
      }
    } else if (this.fullAmountRadioInput.checked) {
      this.customAmountRadioInput.removeAttribute('required');
      chargeTotal = Number(this.amountDue).toFixed(2);
      isAmountValid = true;
    }
    this.chargeTotalInput.value = chargeTotal;
    this.chargeTotalInput.setAttribute('value', chargeTotal);

    const oidGuid = this.oidInput.dataset.orderIdSuffix;
    const oidValue = `${this.bookingDetails.Detail.BookingReference}-${oidGuid}`;
    this.oidInput.value = oidValue;
    this.oidInput.setAttribute('value', oidValue);

    this.getPaymentHash(chargeTotal);
    const firstDataFormFields = {
      ChargeTotal: chargeTotal,
      TxnDate: this.txnDateInput.value,
      Currency: this.bookingDetails.CurrencyCodeNumeric,
      StoreId: this.storeIdInput.value,
    }

    SessionDataManager.setStorageItem(BP_FIRST_DATA_PAYMENT_FORM_KEY, JSON.stringify(firstDataFormFields));

    if (isAmountValid && this.emailInput.value !== "") {
      this.hiddenFormSubmit.removeAttribute('disabled');
      this.customAmountInput.removeAttribute("required");
    }
  }


  getPaymentHash(amount) {
    let StoreId = this.storeIdInput.dataset.paymentStoreId;
    let Amount = amount;
    let TxnDate = this.txnDateInput.dataset.paymentTxnDate;
    let Currency = this.bookingDetails.CurrencyCodeNumeric;
    let data = {
      StoreId,
      Amount,
      TxnDate,
      Currency
    };
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    return fetch('/api/Booking/GetFirstDataHash', {
      method: 'post',
      body: JSON.stringify(data),
      headers: headers
    })
    .then((response) => response.json())
    .then((responseJson) => {
      this.hashInput.value = responseJson;
      this.hashInput.setAttribute('value', responseJson);
    });
  }
}